module.exports = __webpack_public_path__ + "media/images/diy/logo_1-41592b7618b4964714029870a727f43e.png";